<template>
  <div class="bdg__bg" v-if="currentBadge" @click="resetCurrentBadge">
    <div class="bdg__modal" @click.stop>
      <img src="/static/img/ic_close.svg" class="bdg__close" @click="resetCurrentBadge">
      <div class="bdg__ill__container">
        <img src="/static/img/badge_ph.svg" class="bdg__ill" :class="{'closed': !currentBadge.isOpen}">
        <div class="bdg__reward" v-if="currentBadge.isNew">+10</div>
      </div>
      <p class="bdg__name">{{ currentBadge.name }}</p>
      <p class="bdg__description">{{ currentBadge.description }}</p>
      <!-- <p class="bdg__date">12.12.2017</p>
      <div class="bdg__button">Поделиться</div> -->
    </div>
  </div>
</template>
<script>
import Store from '../../store'
export default {
  computed: {
    currentBadge: function () {
      return Store.state.currentBadge
    }
  },
  methods: {
    resetCurrentBadge: function () {
      Store.commit('resetCurrentBadge')
    }
  }
}
</script>



// WEBPACK FOOTER //
// badge-dets.vue?3e8d5b01